import Util, { getSelectedPartner } from "../util/Util";
import { BASE_URIS, TPIS_PARAMS } from "../components/domain/constants";

/**
 * TODO: Move all requests to TPIS endpoints into this service
 */
class TPISRequestService {
  constructor() {
    this.failureCodes = [400, 401, 403, 404];
    this.listExistingImagesRequest = async function (entityId, page, size, ratio, instance) {
      let uri = BASE_URIS.prefix + BASE_URIS.listExistingImages + "?".concat(TPIS_PARAMS.ENTITY_ID, "=").concat(entityId) + "&".concat(TPIS_PARAMS.PAGE, "=").concat(page) + "&".concat(TPIS_PARAMS.PAGE_SIZE, "=").concat(size) + (ratio != null && ratio !== '' ? "&".concat(TPIS_PARAMS.RATIO, "=").concat(ratio) : '');
      return Util.fetchWithRedirect(uri, 'GET', instance.props).then(resp => {
        if (resp != null) {
          if (!this.failureCodes.includes(resp.status)) {
            return resp;
          } else {
            console.error(resp.status);
          }
        }
        return null;
      }).catch(error => {
        Util.log('TPISRequestService.listExistingImagesRequest', true, error, true);
        return null;
      });
    };
  }
}
export default TPISRequestService;